'use client';

import { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { truncateString } from '@/utils/functions/stringFormat';

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export type ConversationItem = {
  id: string;
  title?: string;
  municipality_code: string;
  user_id: string;
  message_count: number;
  created_at: string;
  updated_at: string;
  searchableText?: string;
  actions: ReactNode;
};

export const conversationsColumns: ColumnDef<ConversationItem>[] = [
  {
    accessorKey: 'searchableText',
    header: '',
    enableHiding: true,
    enableColumnFilter: false,
    enableSorting: false,
    size: 0,
    cell: () => null,
  },
  {
    accessorKey: 'title',
    header: 'Título',
    size: 250,
    cell: function TitleCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {row.original.title || '(Sem título)'}
        </div>
      );
    },
  },
  {
    accessorKey: 'municipality_code',
    header: 'Município',
    size: 150,
    cell: function MunicipalityCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[120px]">
          {row.original.municipality_code}
        </div>
      );
    },
  },
  {
    accessorKey: 'user_id',
    header: 'Usuário',
    size: 200,
    cell: function UserCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {truncateString(row.original.user_id, 30)}
        </div>
      );
    },
  },
  {
    accessorKey: 'message_count',
    header: 'Mensagens',
    size: 120,
    cell: function MessageCountCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[100px]">
          {row.original.message_count}
        </div>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Criado em',
    size: 180,
    cell: function CreatedAtCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[160px]">
          {formatDate(row.original.created_at)}
        </div>
      );
    },
  },
  {
    accessorKey: 'updated_at',
    header: 'Atualizado em',
    size: 180,
    cell: function UpdatedAtCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div className="whitespace-normal break-words w-[160px]">
          {formatDate(row.original.updated_at)}
        </div>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: function ActionsCell({ row }: { row: { original: ConversationItem } }) {
      return (
        <div
          className="w-full flex justify-end"
          onClick={(e) => e.stopPropagation()}
        >
          {row.original.actions}
        </div>
      );
    },
  },
];
